// CriticalParameters.js
import React, { useEffect, useState } from 'react';
import {
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  TextField,
  makeStyles,
  Box,
  Typography,
} from '@material-ui/core';
import { AddCircleOutline } from '@material-ui/icons';
import { ReactComponent as TimeProfile } from "../../../../layout/icons/TimeProfile.svg";

const useStyles = makeStyles((theme) => ({
    fieldLabel: {
        fontWeight: 'bold',
        marginBottom: theme.spacing(1),
        },
  table: {
    minWidth: 650,
  },
  tableCell: {
    fontWeight: 600,
  },
  buttonGroup: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-start',
    gap: theme.spacing(2),
  },
  addButton: {
    textTransform: 'none',
    borderRadius: '20px',
    width: '180px',
  },
  saveButton: {
    backgroundColor: '#f06543',
    color: '#fff',
    textTransform: 'none',
    borderRadius: '20px',
    width: '180px',
    '&:hover': {
      backgroundColor: '#d35430',
    },
  },
}));

const CriticalParameters = (props) => {
    const classes = useStyles();
    const { parameters ,sample, data } = props;
  // Updated rows structure according to the new format
  const [rows, setRows] = useState(parameters ? parameters: []);

  const handleValueChange = (index, event) => {
    // const newRows = [...rows];
    // newRows[index].value = event.target.value;
    // setRows(newRows);
    };

    useEffect(() => {
        setRows(parameters ? parameters: [])
    },[parameters])

//   const handleAddNewRecord = () => {
//     setRows([...rows, { parameter: '', upperLimit: '', lowerLimit: '', value: '', uom: '' }]);
//   };

//   const handleSaveChanges = () => {
//     // Handle the save action here
//   };

  return (
    <Container>
      <Typography className={classes.fieldLabel}>{sample ? 'Critical Quality Attributes':'Critical Parameters' }</Typography>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="critical parameters table">
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableCell}>Parameter</TableCell>
              <TableCell className={classes.tableCell}>Range</TableCell>
              <TableCell className={classes.tableCell}>{sample ? 'Value' : 'Value (Time Averaged)'}</TableCell>
              {!sample && <TableCell className={classes.tableCell}>Time Profile</TableCell> }
              <TableCell className={classes.tableCell}>{sample ? 'Unit' : 'Unit of Measure (UOM)'}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow key={index}>
                <TableCell>{row.parameter}</TableCell>
                <TableCell>{row.lowerLimit} to {row.upperLimit}</TableCell>
                <TableCell>
                  <TextField
                    disabled={true}
                    value={row.value}
                    onChange={(e) => handleValueChange(index, e)}
                    // type="number"
                    variant="outlined"
                    size="small"
                    style={{ width: '100px' }}
                  />
                </TableCell>
                {!sample && <TableCell ><TimeProfile /></TableCell> }
                <TableCell>{row.uom}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Button Group */}
      {/* <Box className={classes.buttonGroup}>
        <Button
          variant="outlined"
          startIcon={<AddCircleOutline />}
          className={classes.addButton}
          // disabled={data &&
          //   (data?.unitOperationStatus
          //     ? String(data?.unitOperationStatus).toLowerCase() === 'completed'
          //     : data?.qcSamplingStatus ?
          //       String(data?.qcSamplingStatus).toLowerCase() === 'completed'
          //       : false)}
          disabled={true}
        //   onClick={handleAddNewRecord}
        >
          Add New Record
        </Button>
        <Button
          variant="contained"
          className={classes.saveButton}
          //   onClick={handleSaveChanges}
          // disabled={data &&
          //   (data?.unitOperationStatus
          //     ? String(data?.unitOperationStatus).toLowerCase() === 'completed'
          //     : data?.qcSamplingStatus ?
          //       String(data?.qcSamplingStatus).toLowerCase() === 'completed'
          //       : false)}
          disabled={true}
        >
          Save Changes
        </Button>
      </Box> */}
    </Container>
  );
};

export default CriticalParameters;
